import React, { Component, PropTypes } from 'react';
import {
  StyledThankYouTitle,
  StyledThankYouContent,
  StyledThankYouModal
} from '../FormThankYou/styles';

class ErrorModal extends Component {

  static propTypes = {
    title: PropTypes.string,
    content: PropTypes.string
  }

  static defaultProps = {
    title: '',
    content: '',
  }

  render() {
    const { title, content } = this.props;

    return (
      <StyledThankYouModal>
        <StyledThankYouTitle>{title}</StyledThankYouTitle>
        <StyledThankYouContent>{content}</StyledThankYouContent>
      </StyledThankYouModal>
    )
  }
}

export default ErrorModal;



/** WEBPACK FOOTER **
 ** ./src/components/ErrorModal/index.js
 **/